import React from 'react';

const About = () => {
  return (
    <section id="about" className="about-section section">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <p className="section-description">
          As a developer with a passion for the 
          complete web development lifecycle, I 
          enjoy building comprehensive solutions
           from concept to deployment. I craft dynamic and
            responsive user interfaces with React and JavaScript, 
            while on the backend, I leverage the power of Python and even Laravel
            to build scalable applications. With a solid foundation in SQL 
            databases, I ensure that data is managed effectively. I love creating applications
             that are both powerful and delightful to use.
        </p>
      </div>
    </section>
  );
};

export default About;
